import React, { memo, useMemo } from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { AiActivityTestIds } from '../../../AiActivity.testIds';

import { getRunSnapshotStats } from './RunSnapshot.config';
import {
  asideStyles,
  asideTitleStyles,
  statRowStyles,
  statValueStyles,
} from './RunSnapshot.styles';

const RunSnapshot = ({
  completed,
  total,
  elapsedLabel,
  fieldsFilled = 0,
  fieldsTotal = 0,
  toolCalls = 0,
  guidelineLookups = 0,
  documentsReviewed = 0,
  recordsUpdated = 0,
  recordsRead = 0,
  agentsUsed = 0,
  skillsUsed = 0,
}) => {
  const stats = useMemo(
    () =>
      getRunSnapshotStats({
        completed,
        total,
        elapsedLabel,
        fieldsFilled,
        fieldsTotal,
        toolCalls,
        guidelineLookups,
        documentsReviewed,
        recordsUpdated,
        recordsRead,
        agentsUsed,
        skillsUsed,
      }),
    [
      completed,
      total,
      elapsedLabel,
      fieldsFilled,
      fieldsTotal,
      toolCalls,
      guidelineLookups,
      documentsReviewed,
      recordsUpdated,
      recordsRead,
      agentsUsed,
      skillsUsed,
    ],
  );

  return (
    <Box data-testid={AiActivityTestIds.RUN_SNAPSHOT} sx={asideStyles}>
      <Typography sx={asideTitleStyles} variant="bold12">
        Run snapshot
      </Typography>
      {stats.map(stat => (
        <Box
          data-testid={`${AiActivityTestIds.RUN_SNAPSHOT_STAT}_${stat.id}`}
          key={stat.id}
          sx={statRowStyles}
        >
          <Typography variant="regular12">{stat.label}</Typography>
          <Typography sx={statValueStyles} variant="medium12">
            {stat.value}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

RunSnapshot.propTypes = {
  completed: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  elapsedLabel: PropTypes.string.isRequired,
  fieldsFilled: PropTypes.number,
  fieldsTotal: PropTypes.number,
  toolCalls: PropTypes.number,
  guidelineLookups: PropTypes.number,
  documentsReviewed: PropTypes.number,
  recordsUpdated: PropTypes.number,
  recordsRead: PropTypes.number,
  agentsUsed: PropTypes.number,
  skillsUsed: PropTypes.number,
};

export default memo(RunSnapshot);
